const initialState = {
  activeAudio: null,
  showSidebar: false,
  showModal: false,
  loading: false,
  timeout: false,
  relatedSearches: {
    recommendations: []
  },
  results: {
    aggregations: {},
    matches: [],
    total_hits: 0,
    term: ''
  },
  studioRecommendations: {
    generation: null,
    items: []
  },
  searchHeadings: {
    heading: null,
    sub_heading: null
  },
  ingestedContent: null
}

export default function searchPage (state = initialState, action) {
  switch (action.type) {
    case 'setActiveAudio':
      return {
        ...state,
        activeAudio: action.payload.activeAudio
      }

    case 'fetchSearchResultsRequest':
      return {
        ...state,
        loading: true,
        timeout: false,
        relatedSearches: {
          recommendations: []
        }
      }

    case 'fetchSearchResultsSuccess':
      return {
        ...state,
        results: action.payload.results,
        loading: false
      }

    case 'fetchSearchResultsFailure':
      return {
        ...state,
        loading: false,
        timeout: action.timeout
      }

    case 'fetchRecommendedSearchesByTermResultsSuccess':
      return {
        ...state,
        relatedSearches: {
          type: 'term',
          recommendations: action.payload.recommendations,
          hint: action.payload.hint
        }
      }

    case 'fetchRecommendedSearchesByCategoryResultsSuccess':
      return {
        ...state,
        relatedSearches: {
          type: action.payload.type,
          recommendations: action.payload.recommendations,
          hint: action.payload.hint
        }
      }

    case 'setSearchHeadings':
      return {
        ...state,
        searchHeadings: {
          heading: action.payload.heading || initialState.searchHeadings.heading,
          sub_heading: action.payload.sub_heading || initialState.searchHeadings.sub_heading
        }
      }

    case 'setStudioRecommendations':
      return {
        ...state,
        studioRecommendations: action.payload
      }

    case 'fetchIngestedContentSuccess':
      return {
        ...state,
        ingestedContent: action.payload.content || initialState.ingestedContent
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/searchPage.js